import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../core/guards/auth.guard';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { SearchComponent } from './search/search.component';
import { DbresetComponent } from './dbreset/dbreset.component';
import { DisposComponent } from './dispos/dispos.component';
import { CalendarComponent } from '../shared/calendar/calendar.component';
import { ProspectInfoComponent } from './caller_flow/prospect-info/prospect-info.component';
import { ChooseDispoComponent } from './caller_flow/choose-dispo/choose-dispo.component';
import { AppointmentFormComponent } from './caller_flow/appointment-form/appointment-form.component';
import { CallbackComponent } from './caller_flow/callback/callback.component';
import { My_productionComponent } from './my_production/my_production.component';
import { ReschedulesComponent } from './reschedules/reschedules.component';
import { LeadComponent } from './lead/lead.component';

const routes: Routes = [
	{
		path: '',
		component: CampaignsComponent,
	},
	{
		path: 'search',
		component: SearchComponent,
	},
	{
		path: 'db-reset',
		component: DbresetComponent,
	},
	{
		path: 'dispos',
		component: DisposComponent,
	},
	{
  		path: 'calendar/:alias/:id',
  		component: CalendarComponent
	},
	{
		path: 'prospect-info/:campaign_id/:alias',
		component: ProspectInfoComponent
	},
	{
		path: 'prospect-info/:campaign_id/:alias/:primary_phone',
		component: ProspectInfoComponent
	},
	{
		path: 'choose-dispo/:campaign_id/:alias',
		component: ChooseDispoComponent
	},
	{
		path: 'appointment-form/:campaign_id/:alias',
		component: AppointmentFormComponent
	},
	{
		path: 'callback/:campaign_id/:alias',
		component: CallbackComponent
	},
	{
		path: 'my_production',
		component: My_productionComponent
	},
	{
		path: 'reschedules',
		component: ReschedulesComponent
	},
	{
		path: 'lead/:selectedLead',
		component: LeadComponent
	}

];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],

})
export class ViewsRoutingModule {}
